import { Grid, Theme, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../app/hooks/hooks';
import { goToClaimsBtn, makeRentalReservationBtn, RentalServicesText } from '../../../Constants/Constants';
import { Features } from '../../../types/type';
import { splitTextByWord } from '../../../utils/Utilities';
import CallToAction from '../../shared/CallToAction/CallToAction';
import PropertyServiceInfo from '../../shared/PropertyServiceInfo/PropertyServiceInfo';
import StepProgressBar from '../../shared/StepProgressBar/StepProgressBar';
interface RentalProps {
  hasRentalCoverage: boolean;
  isRentalEligible: boolean;
  rentalLimits: string; // ?
}

export default function RentalServicesHome(props: RentalProps) {
  const navigate = useNavigate();
  const theme: Theme = useTheme();
  const availableProgressStages = useAppSelector((state) => state.services.availableProgressStages);
  const rentalInfo = useAppSelector((state) => state.services.eligibleRentalService);
  const repairComplete = availableProgressStages.some((stage) => stage.id === Features.REPAIR && !!stage.completed);
  const isRentalEligible =
    !!rentalInfo &&
    (!!repairComplete || rentalInfo.serviceDependenciesSatisfied) &&
    !rentalInfo.serviceCustomerCallInMsgCode &&
    !rentalInfo.serviceOpen;
  const headerContent = !rentalInfo ? RentalServicesText.headerNoRentalCoverage : RentalServicesText.headerWithCoverage;
  const headerContent2 = !isRentalEligible ? '' : RentalServicesText.subHeaderWithFullCoverage;
  const rentalIneligibleMessage = !rentalInfo
    ? RentalServicesText.bodyRentalNotCoveredContactToReserve
    : !isRentalEligible
      ? RentalServicesText.bodyRentalEligibleContactToConfirm
      : undefined;

  const reserveInstructionParts = splitTextByWord(
    RentalServicesText.bodyRentalEligibleReserve,
    RentalServicesText.bodyRentalEligibleReserveBold
  );
  const reserveLaterReminderParts = splitTextByWord(
    RentalServicesText.bodyRentalEligibleReserveLater,
    RentalServicesText.bodyRentalEligibleLaterBold
  );

  function handleNext() {
    navigate('/rental-selection');
  }

  async function goToClaimsOverview() {
    navigate('/claims-overview', {
      state: {
        isClaimRefreshNeeded: true,
      },
    });
  }

  return (
    <Box sx={{ width: '100%' }}>
      <StepProgressBar stateInfo={availableProgressStages}></StepProgressBar>
      <PropertyServiceInfo
        headerContent={headerContent}
        infoContent={
          <>
            {rentalInfo && rentalInfo.coverageDescription && (
              <Grid item xs={12}>
                <Typography sx={{ ...theme.custom.styles.titleType3, marginTop: '20px' }}>{headerContent2}</Typography>
                <Typography sx={{ ...theme.custom.styles.titleType2, marginTop: '20px' }}>
                  {RentalServicesText.coveragePrefix}
                </Typography>
                <Typography sx={theme.custom.styles.rentalAmountStyle}>{rentalInfo.coverageDescription}.</Typography>
              </Grid>
            )}
            {!!rentalIneligibleMessage && (
              <Grid item xs={12}>
                <Typography sx={{ marginTop: '20px' }} variant="body1">
                  {rentalIneligibleMessage}
                </Typography>
              </Grid>
            )}

            {!rentalIneligibleMessage && (
              <>
                <Grid item xs={12}>
                  <Typography sx={{ marginTop: '20px' }} variant="body1">
                    {RentalServicesText.bodyRentalEligiblePartner}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ marginTop: '20px' }} variant="body1">
                    {reserveInstructionParts.parts.map((part, index) =>
                      reserveInstructionParts.boldSet.has(part.toLowerCase()) ? (
                        <Typography component="span" sx={{ fontWeight: 'bold' }} key={index}>
                          {part}
                        </Typography>
                      ) : (
                        part
                      )
                    )}
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography sx={{ marginTop: '20px' }} variant="body1">
                    {reserveLaterReminderParts.parts.map((part, index) =>
                      reserveLaterReminderParts.boldSet.has(part.toLowerCase()) ? (
                        <Typography component="span" sx={{ fontWeight: 'bold' }} key={index}>
                          {part}
                        </Typography>
                      ) : (
                        part
                      )
                    )}
                  </Typography>
                </Grid>
              </>
            )}
          </>
        }
      ></PropertyServiceInfo>
      <Grid
        container
        sx={{
          width: '100%',
          maxWidth: '1280px',
          minWidth: '310px',
          margin: '0 auto',
          marginTop: '1em',
        }}
      >
        <Grid item xs={12}>
          <CallToAction
            nextButton={!!isRentalEligible}
            nextButtonContent={makeRentalReservationBtn}
            handleNext={handleNext}
            backButton={false}
            skipButton={false}
            cancelButton={true}
            cancelButtonContent={goToClaimsBtn}
            handleCancel={goToClaimsOverview}
          ></CallToAction>
        </Grid>
      </Grid>
    </Box>
  );
}
